import { useEffect, useState } from 'react'
import { getInstitutionsList } from '../api'
import { mapToOptions } from '../utils/mapToOptions'
import to from 'await-catch'

let inFlightInstitutionsRequest = null

export function useInstitutionOption({ showLoader, hideLoader, addFlashMessage }) {
  const [institutionOptions, setInstitutionOptions] = useState([])
  const [institutions, setInstitutions] = useState([])

  useEffect(() => {
    let isMounted = true

    const fetchData = async () => {
      try {
        showLoader && showLoader()

        if (!inFlightInstitutionsRequest) {
          inFlightInstitutionsRequest = to([getInstitutionsList()]).finally(() => {
            inFlightInstitutionsRequest = null
          })
        }

        const [err, [{ data: institutionsData } = {}]] = await inFlightInstitutionsRequest
        if (err || !Array.isArray(institutionsData) || institutionsData.length === 0) {
          throw new Error('Error en el fetch de instituciones o respuesta vacía')
        }

        if (!isMounted) return

        setInstitutionOptions(
          mapToOptions(institutionsData, 'id', 'descripcion')
        )
        setInstitutions(institutionsData)
      } catch (error) {
        if (!isMounted) return
        addFlashMessage && addFlashMessage('Ocurrió un error cargando las instituciones')
      } finally {
        if (!isMounted) return
        hideLoader && hideLoader()
      }
    }

    fetchData()

    return () => {
      isMounted = false
    }
  }, [showLoader, hideLoader, addFlashMessage])

  return { institutionOptions, institutions }
}
